import i18n from 'i18next'
import { Contact } from '@types'
import { parseInfoField } from 'utils/parseInfoField'

export const prepareContactsCsvData = (data: Contact[]) =>
  data.map(({ firstname, lastname, info, identity, visible, i_userid }) => {
    const { role, cabinet } = parseInfoField(info)

    return {
      firstname,
      lastname,
      role,
      cabinet,
      identity,
      visibility: visible ? i18n.t('common.visible') : i18n.t('common.hidden'),
      id: i_userid || null,
    }
  })
